var _path, _path2, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8424 12H6.25587C2.80085 12 0 14.8008 0 18.2559V57.8424C0 61.2974 2.80085 64.0983 6.25587 64.0983H45.8424C49.2974 64.0983 52.0983 61.2974 52.0983 57.8424V18.2559C52.0983 14.8008 49.2974 12 45.8424 12Z",
    fill: "#B9E2FC",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7444 0H18.6569C14.098 0 10.4023 3.6957 10.4023 8.25458V43.3421C10.4023 47.901 14.098 51.5967 18.6569 51.5967H53.7444C58.3033 51.5967 61.999 47.901 61.999 43.3421V8.25458C61.999 3.6957 58.3033 0 53.7444 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2076_3797",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 12,
    width: 26,
    height: 27
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.2422,
    y: 12.8415,
    width: 25.4796,
    height: 25.4796,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2076_3797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4837 33.862C25.9534 33.862 25.4934 33.6655 25.1037 33.2726C24.7143 32.8794 24.5195 32.4153 24.5195 31.8802V25.3404H30.9714L33.0632 29.5615C33.1482 29.7334 33.271 29.8655 33.4314 29.9581C33.5919 30.0504 33.7605 30.0966 33.9373 30.0966C34.114 30.0966 34.2842 30.0537 34.4478 29.9679C34.6114 29.8821 34.7359 29.7533 34.8211 29.5815L38.6018 22.913L39.5248 24.8053C39.61 24.9837 39.7345 25.1175 39.8981 25.2066C40.0617 25.2958 40.2319 25.3404 40.4086 25.3404H48.0882V31.8802C48.0882 32.4153 47.8934 32.8794 47.504 33.2726C47.1143 33.6655 46.6543 33.862 46.124 33.862H26.4837ZM34.0156 27.0348L32.474 23.8939C32.3889 23.7221 32.2645 23.5899 32.1007 23.4974C31.9371 23.405 31.7669 23.3589 31.5901 23.3589H24.5195V18.0081C24.5195 17.4731 24.7143 17.0089 25.1037 16.6158C25.4934 16.2228 25.9534 16.0263 26.4837 16.0263H46.124C46.6543 16.0263 47.1143 16.2228 47.504 16.6158C47.8934 17.0089 48.0882 17.4731 48.0882 18.0081V23.3589H41.0273L39.5445 20.3464C39.4595 20.168 39.3351 20.0376 39.1713 19.9552C39.0077 19.8726 38.8375 19.8312 38.6607 19.8312C38.484 19.8312 38.317 19.8726 38.1599 19.9552C38.0028 20.0376 37.8817 20.1615 37.7966 20.3268L34.0156 27.0348Z",
    fill: "#0D5DA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.905b6446c9c418133001b420c592ed2c.svg";
export { ForwardRef as ReactComponent };